const readMore = document.querySelector('.js-readmore');
if(readMore) {
    const content = readMore.previousElementSibling;
    const inner = readMore.querySelector('span');
    const maxHeight = 191;

    if (content.scrollHeight > maxHeight) {
        content.style.height = `${maxHeight}px`;
    } else {
        readMore.remove();
    }

    readMore.addEventListener('click', () => {
        if (content.hasAttribute('data-open')) {
            content.style.height = `${maxHeight}px`;
            inner.innerHTML = readMore.getAttribute('data-more');
            setTimeout(() => {
                content.removeAttribute('data-open');
            }, 300);
        } else {
            content.setAttribute('data-open', '');
            content.style.height = `${content.scrollHeight}px`;
            inner.innerHTML = readMore.getAttribute('data-less');
        }
    });
}